import { produce } from "immer";
import ACTIONS from "../actions/types.actions";

const REGION = produce((draft, action) => {
  switch (action.type) {
    case ACTIONS.REGION_REQUEST:
      draft[action.key] = true;
      return draft;
    case ACTIONS.REGION_SUGGESTION_REQUEST:
      draft.suggestionLoading = false;
      draft.error = null;
      return draft;
    case ACTIONS.REGION_SUGGESTION_SUCCESS:
      draft.suggestionLoading = false;
      draft.error = null;
      return draft;
    case ACTIONS.REGION_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.value = action.response;
      return draft;
    case ACTIONS.REGION_LIST_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.list = action.response.list;
      draft.pagination = action.response.pagination;
      return draft;
    case ACTIONS.REGION_SELECTED_LIST_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.selectedList = action.response.list;
      draft.pagination = action.response.pagination;
      return draft;
    default:
      return draft;
  }
});

export default REGION;
